import React, { useRef, useState } from "react";
import classNames from "classnames";

import Button from "components/botanic/Button";

export type CollapsibleChipsProps = {
  chipButtonClassName?: string;
  chips: string[];
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  icon?: any;
  iconClassName?: string;
  initialChipCount?: number;
  isCollapsedOnLoad?: boolean;
  logEvent?: (arg: boolean) => void;
};

const CollapsibleChips = (props: CollapsibleChipsProps) => {
  const {
    chipButtonClassName = "text-xs chip text-default no-underline",
    chips,
    className,
    icon = null,
    iconClassName = "",
    initialChipCount = 5,
    isCollapsedOnLoad = true,
    logEvent = () => {},
  } = props;
  const Icon = icon;
  const [isCollapsed, setIsCollapsed] = useState(isCollapsedOnLoad);
  const buttonRef = useRef(null);
  const initialChips = chips.slice(0, initialChipCount);
  const moreChips = chips.slice(initialChipCount);

  // @ts-ignore (fix me please, do not replicate)
  const toggleIsCollapsed = (e) => {
    e.preventDefault();
    setIsCollapsed((prevIsCollapsed) => !prevIsCollapsed);
    if (!isCollapsed) {
      logEvent(true);
    }
  };

  return (
    <>
      {chips ? (
        initialChips.length > 0 &&
        initialChips.map((chip) => (
          <span
            key={chip}
            data-testid="initial-chip"
            ref={buttonRef}
            className={className}
          >
            <span className="flex">
              {icon && <Icon className={iconClassName} />}
              {chip}
            </span>
          </span>
        ))
      ) : (
        <></>
      )}
      {!!moreChips.length && (
        <>
          <span className={classNames({ hidden: isCollapsed })}>
            {moreChips.map((chip) => (
              <div data-testid="more-chip" key={chip} className={className}>
                <span className="flex">
                  {Icon && <Icon className={iconClassName} />}
                  {chip}
                </span>
              </div>
            ))}
          </span>

          <Button
            aria-expanded={isCollapsed}
            data-testid="show-button"
            className={chipButtonClassName}
            onClick={toggleIsCollapsed}
            variant="text"
          >
            <span>
              {isCollapsed ? `+${moreChips.length} more` : "show less"}
            </span>
          </Button>
        </>
      )}
    </>
  );
};

export default CollapsibleChips;
